import useApiQuery from 'shared/hooks/use-api-query';
import {CityProps} from '../types';

const useCitiesSelect = (enabled = true) => {
  const {data = [], ...rest} = useApiQuery<CityProps[]>({
    url: '/cities/all',
    enabled,
  });

  return {
    ...rest,
    data: data?.map((city: CityProps) => ({
      label: city.name,
      value: city.id,
    })),
  };
};

export default useCitiesSelect;
